import { useWatch } from 'react-hook-form';

import { Component } from 'models';
import { CollectionHelpers } from 'src/helpers/CollectionHelpers';

import { useProductSeriesComponents } from 'hooks/use-product-series-components';

const useDatasheetProductSeriesComponents = () => {
    const [manufacturer, productSeries] = useWatch({
        name: ['manufacturer', 'productSeries'],
    }) as [Component['manufacturer'], Component['productSeries']];

    return useProductSeriesComponents({
        manufacturerId: CollectionHelpers.id(manufacturer),
        productSeries: productSeries,
    });
};

export { useDatasheetProductSeriesComponents };
